<template>
    <el-table :data="data" empty-text="No employees currently assigned" class="w-100">
        <el-table-column label="Id" prop="id"> </el-table-column>
        <el-table-column :prop="USERS_STORE.fields.email" label="Email" sortable> </el-table-column>
        <el-table-column :prop="USERS_STORE.fields.phoneNumber" label="Phone"> </el-table-column>
        <el-table-column label="Status" align="center">
            <template slot-scope="scope">
                <badge
                    v-if="
                        scope.row[STORES.storeEmployees.status] === STORE_EMPLOYEE_STATUS.ADMIN ||
                            scope.row[STORES.storeEmployees.status] === STORE_EMPLOYEE_STATUS.ACTIVE
                    "
                    type="success"
                >
                    Active
                </badge>
                <badge v-else type="danger">
                    Inactive
                </badge>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { Badge } from '@/components/UIComponents'
import { STORE_EMPLOYEE_STATUS } from '@/utils/constants'
import { STORES, USERS_STORE } from 'db'
export default {
    components: {
        Badge
    },
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            STORE_EMPLOYEE_STATUS,
            STORES,
            USERS_STORE
        }
    }
}
</script>
